import { useOnboarding } from '@/hooks/use-onboarding';
import { useEffect } from 'react';

export function DebugTourInfo() {
  const {
    currentTour,
    currentStep,
    currentStepIndex,
    totalSteps,
    isOnboardingActive,
    availableTours,
  } = useOnboarding();

  useEffect(() => {
    // Tour debugging removed - enable in development if needed
  }, [isOnboardingActive, currentTour, currentStep, currentStepIndex, totalSteps]);

  useEffect(() => {
    // Tour debugging removed - enable in development if needed
  }, [availableTours]);

  return null;
}
